<div class="card carddborder">
  <div class="card-header">
    <div class="launch-header">
      <button
        *ngIf="step === 2"
        class="btn btn-light"
        (click)="goToFormStep()"
      >
        <i class="fa fa-angle-left"></i>
        Back
      </button>
      <h5 class="mb-0">Request EC2</h5>
    </div>
  </div>
  <div *ngIf="step === 1" class="card-body form-grid">
    <div class="top-row">
      <div class="form-item">
        <label>AWS Account Id</label>
        <input class="form-control" [ngModel]="accountId" disabled />
      </div>
      <div class="form-item">
        <label>Region</label>
        <input class="form-control" [ngModel]="regionId" disabled />
      </div>
    </div>

    <div class="form-item">
      <label>EC2 Launch Justification <span class="required-star">*</span></label>
      <textarea
        class="form-control"
        [(ngModel)]="form.ec2_launch_justification"
        rows="2"
        required
      ></textarea>
    </div>
    <div class="form-item">
      <label>
        Operating System <span class="required-star">*</span>
        <span *ngIf="loading.os" class="tiny-loader"></span>
      </label>
      <ng-select dropdownPosition="bottom"
        class="instance-type-select"
        [items]="options.os"
        [(ngModel)]="form.operating_system"
        (change)="loadAmis()"
        [searchable]="true"
        [clearable]="true"
        placeholder="Select"
        notFoundText="No operating system found"
        required
      >
      </ng-select>
    </div>
    <div class="form-item">
      <label>
        AMI Id <span class="required-star">*</span>
        <span *ngIf="loading.amis" class="tiny-loader"></span>
      </label>
      <ng-select dropdownPosition="bottom"
        class="instance-type-select"
        [items]="options.amis"
        bindLabel="ami_name"
        bindValue="ami_id"
        [(ngModel)]="form.ami_id"
        [searchable]="true"
        [clearable]="true"
        placeholder="Select"
        notFoundText="No AMI found"
        required
      >
      </ng-select>
    </div>

    <div class="form-item">
      <label>
        Instance Type <span class="required-star">*</span>
        <span *ngIf="loading.instanceTypes" class="tiny-loader"></span>
      </label>
      <ng-select dropdownPosition="bottom"
        class="instance-type-select instance-metadata-select"
        [items]="options.instanceTypes"
        bindLabel="instance_type"
        bindValue="instance_type"
        [(ngModel)]="form.instance_type"
        [searchable]="true"
        [loading]="loading.instanceTypes"
        [clearable]="true"
        placeholder="Select"
        notFoundText="No instance type found"
        required
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="instance-option">
            <div class="instance-option__title">{{ item.instance_type }}</div>
            <div class="instance-option__meta">
              <span>vCPU: {{ item.vcpu ?? "-" }}</span>
              <span>Memory: {{ item.memory || "-" }}</span>
            </div>
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="instance-option">
            <div class="instance-option__title">{{ item.instance_type }}</div>
            <div class="instance-option__meta">
              <span>vCPU: {{ item.vcpu ?? "-" }}</span>
              <span>Memory: {{ item.memory || "-" }}</span>
            </div>
          </div>
        </ng-template>
      </ng-select>
    </div>
    <div class="form-item">
      <label>
        Key Name <span class="required-star">*</span>
        <span *ngIf="loading.keys" class="tiny-loader"></span>
      </label>
      <ng-select dropdownPosition="bottom"
        class="instance-type-select"
        [items]="options.keys"
        bindLabel="key_name"
        bindValue="key_name"
        [(ngModel)]="form.key_name"
        [searchable]="true"
        [clearable]="true"
        placeholder="Select"
        notFoundText="No key found"
        required
      >
      </ng-select>
    </div>

    <div class="form-item">
      <label>
        VPC Id <span class="required-star">*</span>
        <span *ngIf="loading.vpcs" class="tiny-loader"></span>
      </label>
      <ng-select dropdownPosition="bottom"
        class="instance-type-select"
        [items]="options.vpcs"
        bindLabel="vpc_id"
        bindValue="vpc_id"
        [(ngModel)]="form.vpc_id"
        (change)="onVpcChange()"
        [searchable]="true"
        [clearable]="true"
        placeholder="Select"
        notFoundText="No VPC found"
        required
      >
        <ng-template ng-option-tmp let-item="item">
          {{ item.vpc_id }} {{ item.vpc_name ? '- (' + item.vpc_name + ')' : '' }}
        </ng-template>
      </ng-select>
    </div>
    <div class="form-item">
      <label>
        Subnet Id <span class="required-star">*</span>
        <span *ngIf="loading.subnets" class="tiny-loader"></span>
      </label>
      <ng-select dropdownPosition="bottom"
        class="instance-type-select"
        [items]="options.subnets"
        bindLabel="subnet_id"
        bindValue="subnet_id"
        [(ngModel)]="form.subnet_id"
        [searchable]="true"
        [clearable]="true"
        placeholder="Select"
        notFoundText="No subnet found"
        required
      >
        <ng-template ng-option-tmp let-item="item">
          {{ item.subnet_id }} {{ item.subnet_name ? '- (' + item.subnet_name + ')' : '' }}
        </ng-template>
      </ng-select>
    </div>

    <div class="form-item">
      <div class="label-action-row">
        <label class="label-action-row__label">
          Security Group <span class="required-star">*</span>
          <span *ngIf="loading.securityGroups" class="tiny-loader"></span>
        </label>
        <button
          type="button"
          class="icon-action-btn"
          [title]="showCreateSecurityGroupForm ? 'Close create security group form' : 'Create security group'"
          (click)="showCreateSecurityGroupForm ? closeCreateSecurityGroupForm() : openCreateSecurityGroupForm()"
        >
          <i class="fa" [ngClass]="showCreateSecurityGroupForm ? 'fa-times' : 'fa-plus'"></i>
        </button>
      </div>
      <ng-select dropdownPosition="bottom"
        class="instance-type-select"
        [items]="options.securityGroups"
        bindLabel="security_group_name"
        bindValue="security_group_id"
        [(ngModel)]="form.security_group_ids"
        [multiple]="true"
        [searchable]="true"
        [clearable]="true"
        placeholder="Select"
        notFoundText="No security group found"
        required
      >
      </ng-select>
    </div>

    <div class="form-item">
      <label>Associate Public IP <span class="required-star">*</span></label>
      <ng-select dropdownPosition="bottom"
        class="instance-type-select"
        [(ngModel)]="form.associate_public_ip_address"
        [searchable]="false"
        [clearable]="true"
        placeholder="Select"
        required
      >
        <ng-option [value]="true">true</ng-option>
        <ng-option [value]="false">false</ng-option>
      </ng-select>
    </div>

    <div class="form-item mapping-box">
      <div class="mapping-title">Block Device Mappings</div>
      <div class="form-item">
        <label>Device Name</label>
        <input
          class="form-control"
          [(ngModel)]="form.block_device_mappings[0].device_name"
        />
      </div>
      <div class="mapping-subtitle">EBS</div>
      <div class="form-item">
        <label>Volume Size (GB)</label>
        <input
          type="number"
          class="form-control"
          [(ngModel)]="form.block_device_mappings[0].ebs.volume_size"
        />
      </div>
      <div class="form-item">
        <label>Volume Type</label>
        <ng-select dropdownPosition="bottom"
          class="instance-type-select"
          [(ngModel)]="form.block_device_mappings[0].ebs.volume_type"
          [searchable]="false"
          [clearable]="true"
          placeholder="Select"
        >
          <ng-option value="gp2">gp2</ng-option>
          <ng-option value="gp3">gp3</ng-option>
        </ng-select>
      </div>
      <div class="form-item">
        <label>Delete on Termination</label>
        <ng-select dropdownPosition="bottom"
          class="instance-type-select"
          [(ngModel)]="form.block_device_mappings[0].ebs.delete_on_termination"
          [searchable]="false"
          [clearable]="true"
          placeholder="Select"
        >
          <ng-option [value]="true">true</ng-option>
          <ng-option [value]="false">false</ng-option>
        </ng-select>
      </div>
    </div>

    <div class="form-item">
      <label>Instance Name <span class="required-star">*</span></label>
      <input class="form-control" [(ngModel)]="form.instance_name" required />
    </div>

    <div class="form-item tags-wrap">
      <label>Tags <span class="required-star">*</span></label>
      <div *ngFor="let t of form.tags; let i = index" class="tag-row">
        <input class="form-control" placeholder="key" [(ngModel)]="t.key" required />
        <input class="form-control" placeholder="value" [(ngModel)]="t.value" required />
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm tag-remove"
          (click)="removeTag(i)"
          title="Remove tag"
        >
          X
        </button>
      </div>
      <button class="btn btn-light btn-sm" (click)="addTag()">
        <i class="fa fa-plus"></i> Add Tag
      </button>
    </div>

    <div class="form-item">
      <label>HTTP Tokens <span class="required-star">*</span></label>
      <ng-select dropdownPosition="bottom"
        class="instance-type-select"
        [(ngModel)]="form.metadata_options.http_tokens"
        [searchable]="false"
        [clearable]="true"
        placeholder="Select"
        required
      >
        <ng-option value="required">required</ng-option>
        <ng-option value="optional">optional</ng-option>
      </ng-select>
    </div>
    <div class="form-item">
      <label>Monitoring Enabled <span class="required-star">*</span></label>
      <ng-select dropdownPosition="bottom"
        class="instance-type-select"
        [(ngModel)]="form.monitoring.enabled"
        [searchable]="false"
        [clearable]="true"
        placeholder="Select"
        required
      >
        <ng-option [value]="true">true</ng-option>
        <ng-option [value]="false">false</ng-option>
      </ng-select>
    </div>
    <div class="form-item">
      <label>Tenancy <span class="required-star">*</span></label>
      <ng-select dropdownPosition="bottom"
        class="instance-type-select"
        [(ngModel)]="form.placement.tenancy"
        [searchable]="false"
        [clearable]="true"
        placeholder="Select"
        required
      >
        <ng-option value="default">shared</ng-option>
        <ng-option value="dedicated">dedicated</ng-option>
        <ng-option value="host">host</ng-option>
      </ng-select>
    </div>
    <div class="form-item">
      <label>EBS Optimized <span class="required-star">*</span></label>
      <ng-select dropdownPosition="bottom"
        class="instance-type-select"
        [(ngModel)]="form.ebs_optimized"
        [searchable]="false"
        [clearable]="true"
        placeholder="Select"
        required
      >
        <ng-option [value]="true">true</ng-option>
        <ng-option [value]="false">false</ng-option>
      </ng-select>
    </div>
    <div class="form-item">
      <label>Shutdown Behavior <span class="required-star">*</span></label>
      <ng-select dropdownPosition="bottom"
        class="instance-type-select"
        [(ngModel)]="form.instance_initiated_shutdown_behavior"
        [searchable]="false"
        [clearable]="true"
        placeholder="Select"
        required
      >
        <ng-option value="stop">stop</ng-option>
        <ng-option value="terminate">terminate</ng-option>
      </ng-select>
    </div>
    <div class="form-item">
      <label>Architecture <span class="required-star">*</span></label>
      <ng-select dropdownPosition="bottom"
        class="instance-type-select"
        [(ngModel)]="form.architecture"
        [searchable]="false"
        [clearable]="true"
        placeholder="Select"
        required
      >
        <ng-option value="x86_64">x86_64</ng-option>
        <ng-option value="arm64">arm64</ng-option>
      </ng-select>
    </div>
    <div class="form-item">
      <label>User Data</label>
      <textarea
        class="form-control"
        [(ngModel)]="form.user_data"
        rows="2"
      ></textarea>
    </div>

    <div class="form-item">
      <label>
        IAM Instance Profile ARN <span class="required-star">*</span>
        <span *ngIf="loading.iamRoles" class="tiny-loader"></span>
      </label>
      <ng-select dropdownPosition="bottom"
        class="instance-type-select"
        [items]="options.iamRoles"
        bindLabel="instance_profile_arn"
        bindValue="instance_profile_arn"
        [(ngModel)]="form.iam_instance_profile_arn"
        [searchable]="true"
        [clearable]="true"
        [loading]="loading.iamRoles"
        placeholder="Select"
        notFoundText="No IAM role found"
        required
      >
        <ng-template ng-footer-tmp>
          <div
            *ngIf="iamRolesNextToken"
            class="load-more-option cursor-pointer"
            (click)="loadMoreIamRoles($event)"
          >
            {{ loading.iamRoles ? "Loading..." : "Load more" }}
          </div>
        </ng-template>
      </ng-select>
    </div>
  </div>
  <div *ngIf="step === 1" class="card-footer step-footer">
    <button class="btn btn-primary" [disabled]="!canProceedToPricing()" (click)="goToPricingStep()">Next</button>
  </div>

  <app-launch-ec2-pricing-step
    *ngIf="step === 2"
    [apiBaseUrl]="apiBaseUrl"
    [instanceType]="form.instance_type"
    [region]="regionId"
    [operatingSystem]="form.operating_system"
    [requestPayload]="buildSaveRequestBody()"
  ></app-launch-ec2-pricing-step>
</div>

<div
  *ngIf="showCreateSecurityGroupForm"
  class="sg-modal-backdrop"
>
  <div class="sg-modal">
    <div class="sg-modal__header">
      <div class="sg-modal__title-wrap">
        <!-- <div class="sg-modal__badge">
          <i class="fa fa-shield"></i>
        </div> -->
        <div class="sg-create-panel__title">Create Security Group</div>
      </div>
      <button
        type="button"
        class="sg-modal__close"
        [disabled]="loading.createSecurityGroup"
        title="Close"
        (click)="closeCreateSecurityGroupForm()"
      >
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="sg-modal__body">
      <div class="sg-stepper">
        <div
          *ngFor="let stepLabel of createSecurityGroupStepLabels; let i = index"
          class="sg-stepper__item"
          [ngClass]="{
            'is-active': createSecurityGroupStep === i + 1,
            'is-complete': createSecurityGroupStep > i + 1
          }"
        >
          <div class="sg-stepper__circle">
            <ng-container *ngIf="createSecurityGroupStep > i + 1; else sgStepNumber">
              <i class="fa fa-check"></i>
            </ng-container>
            <ng-template #sgStepNumber>{{ i + 1 }}</ng-template>
          </div>
          <div class="sg-stepper__label">{{ stepLabel }}</div>
        </div>
      </div>

      <div *ngIf="createSecurityGroupStep === 1" class="sg-create-section">
        <div class="sg-step-panel__title">Basic details</div>
        <div class="sg-step-panel__subtitle">
          The security group's name and VPC scope. Description is required by AWS.
        </div>

        <div class="sg-create-grid">
          <div class="form-item">
            <label>Name <span class="required-star">*</span></label>
            <input
              class="form-control"
              [ngClass]="{
                'field-invalid':
                  createSecurityGroupSubmitAttempted &&
                  !(createSecurityGroupForm.group_name || '').toString().trim()
              }"
              [(ngModel)]="createSecurityGroupForm.group_name"
              placeholder="e.g. web-tier-sg"
            />
            <div
              *ngIf="
                createSecurityGroupSubmitAttempted &&
                !(createSecurityGroupForm.group_name || '').toString().trim()
              "
              class="field-error"
            >
              Security group name is required.
            </div>
          </div>

          <div class="form-item sg-create-grid__full">
            <label>Description <span class="required-star">*</span></label>
            <input
              class="form-control"
              [ngClass]="{
                'field-invalid':
                  createSecurityGroupSubmitAttempted &&
                  !(createSecurityGroupForm.description || '').toString().trim()
              }"
              [(ngModel)]="createSecurityGroupForm.description"
              placeholder="What this SG protects"
            />
            <div
              *ngIf="
                createSecurityGroupSubmitAttempted &&
                !(createSecurityGroupForm.description || '').toString().trim()
              "
              class="field-error"
            >
              Description is required.
            </div>
          </div>

          <div class="form-item sg-create-grid__full">
            <label>VPC <span class="required-star">*</span></label>
            <ng-select dropdownPosition="bottom"
              class="instance-type-select"
              [ngClass]="{
                'invalid-select':
                  createSecurityGroupSubmitAttempted &&
                  !(createSecurityGroupForm.vpc_id || '').toString().trim()
              }"
              [items]="options.vpcs"
              bindLabel="vpc_id"
              bindValue="vpc_id"
              [(ngModel)]="createSecurityGroupForm.vpc_id"
              [searchable]="true"
              [clearable]="true"
              placeholder="Select VPC"
              notFoundText="No VPC found"
            >
              <ng-template ng-option-tmp let-item="item">
                {{ getCreateSecurityGroupVpcLabel(item.vpc_id) }}
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                createSecurityGroupSubmitAttempted &&
                !(createSecurityGroupForm.vpc_id || '').toString().trim()
              "
              class="field-error"
            >
              VPC is required.
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="createSecurityGroupStep === 2" class="sg-create-section">
        <div class="sg-step-panel__title">Inbound rules</div>
        <div class="sg-step-panel__subtitle">
          Allow traffic INTO resources attached to this group. Critical ports (22 SSH, 3389 RDP)
          open to 0.0.0.0/0 are flagged.
        </div>

        <div class="sg-rule-editor">
          <div class="sg-rule-editor__header">
            <span>Protocol</span>
            <span>Port</span>
            <span>Source</span>
            <span>Description</span>
            <span></span>
          </div>

          <div
            *ngFor="let rule of createSecurityGroupForm.inbound_rules; let i = index"
            class="sg-rule-block"
          >
            <div class="sg-rule-row">
              <div class="sg-rule-field">
                <label class="sg-rule-field__mobile-label">Protocol</label>
                <select
                  class="form-control"
                  [(ngModel)]="rule.protocol"
                  (ngModelChange)="onCreateSecurityGroupRuleProtocolChange(rule)"
                >
                  <option *ngFor="let protocol of createSecurityGroupProtocolOptions" [value]="protocol">
                    {{ protocol }}
                  </option>
                </select>
              </div>

              <div class="sg-rule-field">
                <label class="sg-rule-field__mobile-label">Port</label>
                <input
                  class="form-control"
                  [ngClass]="{
                    'field-invalid':
                      createSecurityGroupSubmitAttempted &&
                      !isCreateSecurityGroupRuleValid(rule, 'inbound')
                  }"
                  [(ngModel)]="rule.port"
                  [disabled]="!usesCreateSecurityGroupRulePort(rule.protocol)"
                  [placeholder]="usesCreateSecurityGroupRulePort(rule.protocol) ? '443' : '-'"
                />
              </div>

              <div class="sg-rule-field">
                <label class="sg-rule-field__mobile-label">Source</label>
                <input
                  class="form-control"
                  [ngClass]="{
                    'field-invalid':
                      createSecurityGroupSubmitAttempted &&
                      !isCreateSecurityGroupRuleValid(rule, 'inbound')
                  }"
                  [(ngModel)]="rule.target"
                  placeholder="0.0.0.0/0"
                />
              </div>

              <div class="sg-rule-field">
                <label class="sg-rule-field__mobile-label">Description</label>
                <input
                  class="form-control"
                  [ngClass]="{
                    'field-invalid':
                      createSecurityGroupSubmitAttempted &&
                      !isCreateSecurityGroupRuleValid(rule, 'inbound')
                  }"
                  [(ngModel)]="rule.description"
                  placeholder="HTTPS"
                />
              </div>

              <button
                type="button"
                class="sg-rule-remove"
                (click)="removeCreateSecurityGroupRule('inbound', i)"
                title="Remove inbound rule"
              >
                <i class="fa fa-trash"></i>
              </button>
            </div>

            <div
              *ngIf="
                createSecurityGroupSubmitAttempted &&
                !isCreateSecurityGroupRuleValid(rule, 'inbound')
              "
              class="field-error"
            >
              {{ getCreateSecurityGroupRuleValidationMessage(rule, 'inbound') }}
            </div>

            <div *ngIf="isCreateSecurityGroupRuleFlagged(rule)" class="sg-rule-warning">
              This inbound rule opens SSH or RDP access to the world.
            </div>
          </div>
        </div>

        <button
          type="button"
          class="sg-add-rule-btn"
          (click)="addCreateSecurityGroupRule('inbound')"
        >
          <i class="fa fa-plus"></i> Add inbound rule
        </button>
      </div>

      <div *ngIf="createSecurityGroupStep === 3" class="sg-create-section">
        <div class="sg-step-panel__title">Outbound rules</div>
        <div class="sg-step-panel__subtitle">
          Allow traffic OUT FROM resources attached to this group.
        </div>

        <div class="sg-rule-editor">
          <div class="sg-rule-editor__header">
            <span>Protocol</span>
            <span>Port</span>
            <span>Destination</span>
            <span>Description</span>
            <span></span>
          </div>

          <div
            *ngFor="let rule of createSecurityGroupForm.outbound_rules; let i = index"
            class="sg-rule-block"
          >
            <div class="sg-rule-row">
              <div class="sg-rule-field">
                <label class="sg-rule-field__mobile-label">Protocol</label>
                <select
                  class="form-control"
                  [(ngModel)]="rule.protocol"
                  (ngModelChange)="onCreateSecurityGroupRuleProtocolChange(rule)"
                >
                  <option *ngFor="let protocol of createSecurityGroupProtocolOptions" [value]="protocol">
                    {{ protocol }}
                  </option>
                </select>
              </div>

              <div class="sg-rule-field">
                <label class="sg-rule-field__mobile-label">Port</label>
                <input
                  class="form-control"
                  [ngClass]="{
                    'field-invalid':
                      createSecurityGroupSubmitAttempted &&
                      !isCreateSecurityGroupRuleValid(rule, 'outbound')
                  }"
                  [(ngModel)]="rule.port"
                  [disabled]="!usesCreateSecurityGroupRulePort(rule.protocol)"
                  [placeholder]="usesCreateSecurityGroupRulePort(rule.protocol) ? '443' : '-'"
                />
              </div>

              <div class="sg-rule-field">
                <label class="sg-rule-field__mobile-label">Destination</label>
                <input
                  class="form-control"
                  [ngClass]="{
                    'field-invalid':
                      createSecurityGroupSubmitAttempted &&
                      !isCreateSecurityGroupRuleValid(rule, 'outbound')
                  }"
                  [(ngModel)]="rule.target"
                  placeholder="0.0.0.0/0"
                />
              </div>

              <div class="sg-rule-field">
                <label class="sg-rule-field__mobile-label">Description</label>
                <input
                  class="form-control"
                  [ngClass]="{
                    'field-invalid':
                      createSecurityGroupSubmitAttempted &&
                      !isCreateSecurityGroupRuleValid(rule, 'outbound')
                  }"
                  [(ngModel)]="rule.description"
                  placeholder="Allow all outbound"
                />
              </div>

              <button
                type="button"
                class="sg-rule-remove"
                (click)="removeCreateSecurityGroupRule('outbound', i)"
                title="Remove outbound rule"
              >
                <i class="fa fa-trash"></i>
              </button>
            </div>

            <div
              *ngIf="
                createSecurityGroupSubmitAttempted &&
                !isCreateSecurityGroupRuleValid(rule, 'outbound')
              "
              class="field-error"
            >
              {{ getCreateSecurityGroupRuleValidationMessage(rule, 'outbound') }}
            </div>
          </div>
        </div>

        <button
          type="button"
          class="sg-add-rule-btn"
          (click)="addCreateSecurityGroupRule('outbound')"
        >
          <i class="fa fa-plus"></i> Add outbound rule
        </button>
      </div>

      <div *ngIf="createSecurityGroupStep === 4" class="sg-create-section">
        <div class="sg-step-panel__title">Tag the security group</div>

        <div class="form-item sg-tag-field">
          <label>Environment</label>
          <ng-select dropdownPosition="bottom"
            class="instance-type-select"
            [clearable]="false"
            [searchable]="false"
            [(ngModel)]="createSecurityGroupForm.environment"
          >
            <ng-option
              *ngFor="let environment of createSecurityGroupEnvironmentOptions"
              [value]="environment"
            >
              {{ environment }}
            </ng-option>
          </ng-select>
        </div>
      </div>

      <div *ngIf="createSecurityGroupStep === 5" class="sg-create-section">
        <div class="sg-review-banner">
          The security group will be created first, then the inbound and outbound rules will be applied.
        </div>

        <div class="sg-review-card">
          <div class="sg-review-row">
            <span>Name</span>
            <strong>{{ createSecurityGroupForm.group_name || "-" }}</strong>
          </div>
          <div class="sg-review-row">
            <span>Description</span>
            <strong>{{ createSecurityGroupForm.description || "-" }}</strong>
          </div>
          <div class="sg-review-row">
            <span>VPC</span>
            <strong>{{ getCreateSecurityGroupVpcLabel(createSecurityGroupForm.vpc_id) }}</strong>
          </div>
          <div class="sg-review-row">
            <span>Inbound rules</span>
            <strong>{{ getCreateSecurityGroupRuleCountLabel('inbound') }}</strong>
          </div>
          <div class="sg-review-row">
            <span>Outbound rules</span>
            <strong>{{ getCreateSecurityGroupRuleCountLabel('outbound') }}</strong>
          </div>
          <div class="sg-review-row">
            <span>Environment</span>
            <strong>{{ createSecurityGroupForm.environment || "-" }}</strong>
          </div>
        </div>

        <div class="sg-review-rules">
          <div class="sg-review-rules__title">Inbound:</div>
          <ul>
            <li *ngFor="let rule of createSecurityGroupForm.inbound_rules">
              {{ formatCreateSecurityGroupRuleForReview(rule, 'inbound') }}
            </li>
          </ul>

          <div class="sg-review-rules__title">Outbound:</div>
          <ul>
            <li *ngFor="let rule of createSecurityGroupForm.outbound_rules">
              {{ formatCreateSecurityGroupRuleForReview(rule, 'outbound') }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="sg-modal__footer">
      <div class="sg-create-actions">
        <button
          *ngIf="createSecurityGroupStep === 1"
          type="button"
          class="btn btn-light"
          [disabled]="loading.createSecurityGroup"
          (click)="closeCreateSecurityGroupForm()"
        >
          Cancel
        </button>
        <button
          *ngIf="createSecurityGroupStep > 1"
          type="button"
          class="btn btn-light"
          [disabled]="loading.createSecurityGroup"
          (click)="previousCreateSecurityGroupStep()"
        >
          &larr; Back
        </button>

        <div class="sg-create-actions__meta">
          Step {{ createSecurityGroupStep }} of {{ createSecurityGroupStepLabels.length }}
        </div>

        <button
          *ngIf="createSecurityGroupStep < createSecurityGroupStepLabels.length"
          type="button"
          class="btn btn-primary sg-next-btn"
          [disabled]="loading.createSecurityGroup"
          (click)="nextCreateSecurityGroupStep()"
        >
          Next &rarr;
        </button>
        <button
          *ngIf="createSecurityGroupStep === createSecurityGroupStepLabels.length"
          type="button"
          class="btn sg-create-submit-btn"
          [disabled]="loading.createSecurityGroup"
          (click)="submitCreateSecurityGroup()"
        >
          <span *ngIf="loading.createSecurityGroup" class="spinner-border spinner-border-sm me-2"></span>
          {{ loading.createSecurityGroup ? "Creating..." : "Create security group" }}
        </button>
      </div>
    </div>
  </div>
</div>
